import { useGlobalAlias } from '@/common/hook/useGlobalAlias';

/**
 * @Description 外部快捷打开工具箱枚举
 */
export const ToolBoxChangeOperationObj = {
  /** 测距 */
  RULER: 'ruler',
  /** 圈选查询  */
  DRAW_SEARCH: 'drawSearch',
  /** 打靶任务 */
  CHECK_IN_FIELD_A: 'checkInFieldA',
  /** 新增品牌商圈 */
  BRAND_BUSINESS_AREA: 'brandBusinessArea',
  /** 新增商圈/新增开店区域 */
  OPENING_AREA: 'openingArea',
  /** 创建门店 */
  STANDARD_SHOP_CREATE: 'standardShopCreate',
  /** 点位测评 */
  DRAW_POINT: 'drawPoint',
  /** 创建机会点 */
  STANDARD_CHANCE_POINT_CREATE: 'standardChancePointCreate',
  /** 管理片区 */
  MANAGE_AREA: 'manageArea',
  /** 新增管理片区 */
  XTC_MANAGEMENT_AREA_ADD: 'xtcManagementAreaAdd',
  /** 编辑管理片区 */
  XTC_MANAGEMENT_AREA_EDIT: 'xtcManagementAreaEdit',
};

/**
 * @Description 外部快捷打开工具箱类型
 */
export type ToolBoxChangeOperationEnum = typeof ToolBoxChangeOperationObj[keyof typeof ToolBoxChangeOperationObj];

/**
 * @Description 工具类枚举
 */
export const mergeToolBoxType = Object.assign(ToolBoxChangeOperationObj, {
  /** 标记 */
  DOT_MARK: 'dotMark',
  /** 卫星 */
  SATELLITE: 'satellite',

});

/**
 * @Description 工具类类型
 */
export type ToolBoxType = typeof mergeToolBoxType[keyof typeof mergeToolBoxType];


/**
 * @Description 获取右键和工具箱工具箱key和name列表，处理过别名
 */
export const useToolBoxList = () => {
  /** 获取打卡别名 */
  const targetPunchInAlias = useGlobalAlias(ToolBoxChangeOperationObj.CHECK_IN_FIELD_A);
  // 获取【机会点】别名
  const chanceNameAlias = useGlobalAlias('standardChancePoint');
  // 获取【品牌商圈】别名
  const brandBusinessArea = useGlobalAlias(ToolBoxChangeOperationObj.BRAND_BUSINESS_AREA);
  // 获取【商圈】别名
  const openingAreaAlias = useGlobalAlias(ToolBoxChangeOperationObj.OPENING_AREA);
  // 获取【管理片区】别名
  const manageAreaAlias = useGlobalAlias(ToolBoxChangeOperationObj.MANAGE_AREA);
  const xtcManageArea = '管理片区';

  // 预先定义需要使用 useGlobalAlias 的 key 和其对应的别名
  const globalAliasMap: Record<string, string> = {
    [mergeToolBoxType.CHECK_IN_FIELD_A]: `${targetPunchInAlias}任务`,
    [mergeToolBoxType.BRAND_BUSINESS_AREA]: brandBusinessArea,
    [mergeToolBoxType.OPENING_AREA]: openingAreaAlias,
    [mergeToolBoxType.STANDARD_CHANCE_POINT_CREATE]: chanceNameAlias,
    [mergeToolBoxType.MANAGE_AREA]: manageAreaAlias,
    [mergeToolBoxType.XTC_MANAGEMENT_AREA_ADD]: xtcManageArea,
    [mergeToolBoxType.XTC_MANAGEMENT_AREA_EDIT]: xtcManageArea,
  };
  // 遍历枚举生成数组
  const items = Object.values(mergeToolBoxType).map(key => {
    const name = globalAliasMap[key] || key;
    return {
      name,
      key,
    };
  });

  // 替换某个 key 的 name映射表
  const aliasMap: Record<string, string> = {
    [mergeToolBoxType.STANDARD_SHOP_CREATE]: '新增门店',
    [mergeToolBoxType.DRAW_POINT]: '点位测评',
    [mergeToolBoxType.RULER]: '测距',
    [mergeToolBoxType.DRAW_SEARCH]: '圈选查询',
    [mergeToolBoxType.SATELLITE]: '卫星',
    [mergeToolBoxType.STANDARD_CHANCE_POINT_CREATE]: chanceNameAlias
  };

  return items.map(item => ({
    ...item,
    name: aliasMap[item.key] ?? item.name,
  }));
};

